import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button/Button';
import { onContentSelected } from 'store/servicioWhatsapp/servicioWhatsappSlice';
import { useAppDispatch } from 'hooks/reduxHooks';

export const InicioText = () => {
    const dispatch = useAppDispatch();
    return (
        <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} margin={2} textAlign={"start"} justifyContent={'center'}>
                <Typography
                    variant="body1"
                >
                    Este servicio tiene como objetivo principal enviar, de manera simultánea, las notificaciones que ya recibes mediante correo electrónico, ahora también a tu smartphone vía WhatsApp.
                </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} margin={2} display={'flex'}>
                    <Button style={{marginRight: '5px'}} variant="outlined" onClick={() => dispatch(onContentSelected('noEstoyInteresado'))} >No me interesa</Button>
                    <Button variant="contained" onClick={() => dispatch(onContentSelected('avisoDePrivacidad'))}>Si estoy interesado</Button>
            </Grid>
          
        </Grid>
    )
}
